class multiStepForm {
    
    constructor(form, validators,onBasketSend, onTabShow) {
        this.mobileViewport = window.matchMedia('(max-width:991.98px)');
        this.isMobile = this.mobileViewport.matches;
        
        this.currentStepIndex = 0;
        this.validators = validators;

        this.navigation = Array.prototype.slice.call(form.querySelectorAll('.cart-page-navbar a'));
        this.formTabsWrapper = form.querySelector('.cart-page-content');
        this.formTabs = [];

        this.onBasketSend = onBasketSend;
        this.onTabShow = onTabShow;

        this.tabChanged = function (index) {

        };

        this.navigation.forEach((link) => {
            let target = link.getAttribute('data-target');
            this.formTabs.push(form.querySelector(target));
        });

        this.prevButton = document.getElementById('cart-form-nav-prev');
        this.nextButton = document.getElementById('cart-form-nav-next');

        if (this.isMobile) {
            this.updateMobileView();
        } 
        
        this.assignEvents();
        this.showTab();
    }

    onTabChange(callback) {
        this.tabChanged = callback;
    }
    
    updateMobileView() {
        this.formTabs.forEach(tab => {
            tab.classList.remove('tab-pane', 'active');
            tab.classList.add('collapse');
        });

        this.navigation.forEach((link, index) => {

            link.parentElement.classList.remove('active');
            link.parentElement.appendChild(this.formTabs[index]);
            
        });

    }

    updateDesktopView(){
        this.formTabs.forEach(tab => {
            tab.classList.remove('collapse', 'in');
            tab.classList.add('tab-pane');
            tab.removeAttribute('style');
            this.formTabsWrapper.appendChild(tab);
        });
    }

    collapseTabs() {
        this.formTabs.forEach(tab => {
            $(tab).collapse('hide');
        });
    }
    
    showTab() {
        if (this.currentStepIndex < 0) {
            if(confirm('Czy wyjść z koszyka?')) {

                window.location.href = '/pierscionki-zareczyny/';
                this.currentStepIndex = 0;
            }

        } else if (this.currentStepIndex > this.navigation.length - 1) {
            this.onBasketSend();
            this.currentStepIndex = this.navigation.length - 1;
        } else {
            if (this.isMobile) {
                this.collapseTabs();
                $(this.formTabs[this.currentStepIndex]).collapse('show');
            } else {
                $(this.navigation[this.currentStepIndex]).tab('show');
            }

            this.tabChanged(this.currentStepIndex);
        }

        this.nextButton.innerHTML = this.currentStepIndex === 2 ? 'Złóż zamówienie z obowiązkiem zapłaty' : 'Dalej';

        if (this.currentStepIndex === 2) {
            if($('#basketorder-create_account-1').prop('checked')) {
                $('#accountControllAgreement').parent().parent().removeClass('hidden');
            } else {
                $('#accountControllAgreement').parent().parent().addClass('hidden');
            }
        }
    }

    validateOnTabChange() {
        let isOk = this.validators[this.currentStepIndex].validate();
        if(isOk) {
            this.currentStepIndex = this.currentStepIndex + 1;
            if(this.currentStepIndex === 1) {
                this.onTabShow(this.currentStepIndex);
            }

            this.showTab();
        }
    }

    assignEvents() {
        this.navigation.forEach(link => {
            link.addEventListener('click', () => {
                this.validateOnTabChange();
            });
        });

        this.prevButton.addEventListener('click', () => {
            this.currentStepIndex = this.currentStepIndex - 1;
            this.showTab();
        });

        this.nextButton.addEventListener('click', () => {
            this.validateOnTabChange();
        });

        this.mobileViewport.addListener((e) => {
            this.isMobile = e.matches;
            if (this.isMobile) {
                this.updateMobileView();
            } else {
                this.updateDesktopView();
            }
            this.showTab();
        });
    }
}

export default multiStepForm;
